import React from 'react'
import Head from 'components/Head'
import SiteLayout from 'components/SiteLayout'
import { usePageView } from 'hooks'
import { getStaticWrapper } from 'utils'

const MessagingTerms = () => {
  usePageView()
  return (
    <SiteLayout hideBanner>
      <Head title='Messaging Terms & Conditions | Barstool Sports' />
      <section className='container'>
        <article className='staticPage'>
          <header className='staticPage__header'>
            <h1>Messaging Terms &amp; Conditions</h1>
          </header>
          <section className='staticPage__content'>
            <p>
              Barstool Sports, Inc. (&ldquo;Barstool&rdquo; or &ldquo;we&rdquo;, &ldquo;our&rdquo; or &ldquo;us&rdquo;)
              operates the Barstool Sports platform, which includes the Barstool Sports website, the Barstool Store, our
              subscription service(s) (if any), our affiliated websites, mobile apps, and OTT apps such as One Bite,
              Barstool Bets and Old Row, and all related social media pages (the foregoing, and all content, features,
              and materials thereon, shall hereinafter be collectively referred to as the &ldquo;Platform&rdquo;).
            </p>
            <p>
              From time to time, we may ask if you would like to receive marketing text messages (defined below) from us
              in connection with the Platform or certain aspects of it (e.g., the Barstool Store). &nbsp;If you choose
              to receive marketing text messages, these Messaging Terms and Conditions will apply.
            </p>

            <h2>Overview</h2>

            <p>
              By choosing to receive marketing text messages from us, you agree to receive recurring automated
              promotional and personalized marketing text (e.g., SMS and MMS) messages (e.g. cart reminders)
              (&ldquo;marketing texts&rdquo;) from Barstool including, for example, text messages that may be sent using
              an automatic telephone dialing system, to the mobile telephone number you provided when signing up or any
              other number that you designate. Consent to receive automated marketing text messages is not a condition
              of any purchase. Msg &amp; Data rates may apply.
            </p>
            <p>
              Message frequency will vary. Barstool reserves the right to alter the frequency of messages sent at any
              time, so as to increase or decrease the total number of sent messages. Barstool also reserves the right to
              change the short code or phone number from which messages are sent and we will notify you when we do so.
            </p>
            <p>
              Not all mobile devices or handsets may be supported and our messages may not be deliverable in all areas.
              Barstool, its service providers and the mobile carriers supported by the program are not liable for
              delayed or undelivered messages.
            </p>
            <p>
              Through our service provider, Attentive Mobile, Inc., we are able to deliver messages to the following
              mobile phone carriers: Major carriers: AT&amp;T, Verizon Wireless, Sprint, T-Mobile, MetroPCS, U.S.
              Cellular, Alltel, Boost Mobile, Nextel, and Virgin Mobile. Minor carriers: Alaska Communications Systems
              (ACS), Appalachian Wireless (EKN), Bluegrass Cellular, Cellular One of East Central IL (ECIT), Cellular
              One of Northeast Pennsylvania, Cincinnati Bell Wireless, Cricket, Coral Wireless (Mobi PCS), COX, Cross,
              Element Mobile (Flat Wireless), Epic Touch (Elkhart Telephone), GCI, Golden State, Hawkeye (Chat
              Mobility), Hawkeye (NW Missouri), Illinois Valley Cellular, Inland Cellular, iWireless (Iowa Wireless),
              Keystone Wireless (Immix Wireless/PC Man), Mosaic (Consolidated or CTC Telecom), Nex-Tech Wireless,
              NTelos, Panhandle Communications, Pioneer, Plateau (Texas RSA 3 Ltd), Revol, RINA, Simmetry (TMP
              Corporation), Thumb Cellular, Union Wireless, United Wireless, Viaero Wireless, and West Central (WCC or 5
              Star Wireless).
            </p>

            <h2>Cancellation</h2>
            <p>
              Text the keyword STOP, END, CANCEL, UNSUBSCRIBE or QUIT to our shortcode to cancel. After texting STOP,
              END, CANCEL, UNSUBSCRIBE or QUIT to our shortcode you will receive one additional message confirming that
              your request has been processed. You acknowledge that our text message platform may not recognize and
              respond to unsubscribe requests that do not include the STOP, END, CANCEL, UNSUBSCRIBE or QUIT keyword
              commands and agree that Barstool and its service providers will have no liability for failing to honor
              such requests. If you unsubscribe from one of our text message programs, you may continue to receive text
              messages from Barstool through any other programs you have joined until you separately unsubscribe from
              those programs.
            </p>
            <h2>HELP</h2>
            <p>Text the keyword HELP to our shortcode to return customer care contact information.</p>
            <h2>CUSTOMER CARE</h2>
            <p>
              If you are experiencing any problems, please visit{' '}
              <a href='https://support.attentivemobile.com/help/'>https://support.attentivemobile.com/help/</a> and
              submit the form with details about your problem or your request for support, or email
              support@attentivemobile.com.
            </p>

            <h2>CONTACT</h2>
            <p>
              This message program is a service of Barstool, located at 333 7<sup>th</sup> Avenue, Floor 2, New York, NY
              10001, provided through Barstool&rsquo;s service provider, Attentive Mobile, Inc.
            </p>

            <h2>DISPUTE RESOLUTION</h2>
            <p>
              Any controversy or claim arising out of or relating to these Messaging Terms and Conditions, their
              enforcement or interpretation, because of an alleged breach, default or misrepresentation in connection
              with any of their provisions, or otherwise in connection with your receipt of marketing text messages from
              Barstool or its service providers, shall be determined by binding arbitration in accordance with the
              Binding Arbitration section of our <a href='https://www.barstoolsports.com/terms-of-use'>Terms of Use</a>
              .&nbsp;
            </p>

            <h2>INCORPORATION OF TERMS OF USE</h2>
            <p>
              These Messaging Terms and Conditions supplement our{' '}
              <a href='https://www.barstoolsports.com/terms-of-use'>Terms of Use</a>, the provisions of which are hereby
              incorporated by this reference and constitute the remainder of the terms governing the subject matter
              hereof. By choosing to receive marketing text messages from us, you are representing that you have read
              and agree to these Messaging Terms and Conditions and our Terms of Use, and that you understand and
              acknowledge our <a href='https://www.barstoolsports.com/privacy-policy'>Privacy Policy</a>.
            </p>
          </section>
        </article>
      </section>
    </SiteLayout>
  )
}

export const getStaticProps = getStaticWrapper()

export default MessagingTerms
